//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

import React from "react";
import { Typography } from "@material-ui/core";
//......keep this import at last......
import { useStyles } from "./Styles";
import WhatsappContact from "./WhatsappContact";

function About() {
  const classes = useStyles();
  return (
    <div
      id="otherComponents"
      className={classes.otherComponents}
      style={{ overflowY: "scroll", overflowX: "hidden" }}
    >
      <div>
        <Typography
          variant="h5"
          color="inherit"
          className=""
          style={{ fontSize: "2.4vw" }}
        >
          About Me <br />
          <br />
        </Typography>
      </div>
      <Typography align="justify" variant="h6" color="textSecondary">
        <div style={{ margin: "0px", float: "left" }}>
          <span style={{ float: "left" }}>
            <img
              src="images/about/computer.svg"
              className={classes.aboutIcons}
            />
          </span>
          <div style={{ display: "inline-block" }}>
            I am a computer science graduate from India. I love new next gen
            technologies and more than that I love photography.
          </div>
        </div>
        <br />
        <div style={{ margin: "0px", float: "left" }}>
          <span style={{ float: "left" }}>
            <img
              src="images/about/photography.svg"
              className={classes.aboutIcons}
            />
          </span>
          <div style={{ display: "inline-block" }}>
            Life is as beautiful as our eyes see, that's why I love to capture
            and show people the way I see the world through my photographs.
          </div>
        </div>
        <br />
        <div style={{ margin: "0px", float: "left" }}>
          <span style={{ float: "left" }}>
            <img
              src="images/about/creative.svg"
              className={classes.aboutIcons}
            />
          </span>
          <br />
          <div style={{ display: "inline-block" }}>
            Apart from this I like sketching, coloring, origami crafts, anything
            that involves creativity.
          </div>
        </div>
        <br />
        <br />
        <div style={{ margin: "0px", float: "left" }}>
          <span style={{ float: "left" }}>
            <img src="images/about/coffee.svg" className={classes.aboutIcons} />
          </span>
          <div style={{ display: "inline-block" }}>
            Coffee is my second love, it drives me crazy. Food experiments as
            well as photography experiments is what I used to carry out in my
            free/part times.
          </div>
        </div>
        <br />
        <div style={{ margin: "0px", float: "left" }}>
          <span style={{ float: "left" }}>
            <img src="images/about/space.svg" className={classes.aboutIcons} />
          </span>
          <div style={{ display: "inline-block" }}>
            Space explorations has always been my dream that's why I love night
            time where I can use my zoom lens to see beyond my horizon :)
          </div>
        </div>
      </Typography>

      {/* <WhatsappContact />   */}

    </div>
  );
}
export default About;
